import React from 'react'
import { useRawTranslation } from '@morningtrain/react-translations'

export default function ForEachWeekday ({ children }) {
  const weekdayTranslations = useRawTranslation('generic.weekdays.normal', false)

  const weekdays = [
    {
      index: 1,
      name: weekdayTranslations.monday
    },
    {
      index: 2,
      name: weekdayTranslations.tuesday
    },
    {
      index: 3,
      name: weekdayTranslations.wednesday
    },
    {
      index: 4,
      name: weekdayTranslations.thursday
    },
    {
      index: 5,
      name: weekdayTranslations.friday
    },
    {
      index: 6,
      name: weekdayTranslations.saturday
    },
    {
      index: 7,
      name: weekdayTranslations.sunday
    }
  ]

  return weekdays.map(weekday => (
    <React.Fragment key={weekday.index}>
      {children(weekday)}
    </React.Fragment>
  ))
}
